import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "opModal" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "text-red" }, " Ricerca anagrafiche ", -1);
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-md-6" };
const _hoisted_5 = { class: "form-group" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", null, "Nome", -1);
const _hoisted_7 = { class: "form-group" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", null, "Cognome", -1);
const _hoisted_9 = { class: "form-group" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("label", null, "Codice fiscale", -1);
const _hoisted_11 = { class: "col-md-6" };
const _hoisted_12 = { class: "form-group" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", null, "Ragione sociale", -1);
const _hoisted_14 = { class: "form-group" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("label", null, "P. Iva", -1);
const _hoisted_16 = { class: "form-group" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("label", null, "Codice JDE", -1);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_19 = { class: "max-h-400" };
const _hoisted_20 = { class: "table" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("td", null, "Codice JDE"),
        /*#__PURE__*/ _createElementVNode("td", null, "Nome / Ragione sociale"),
        /*#__PURE__*/ _createElementVNode("td", null, "Codice Fiscale"),
        /*#__PURE__*/ _createElementVNode("td", null, "Partita iva")
    ])
], -1);
const _hoisted_22 = { key: 0 };
const _hoisted_23 = ["onClick"];
const _hoisted_24 = { class: "d-flex justify-content-center mt-2" };
const _hoisted_25 = ["disabled"];
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
    type: "button",
    class: "btn btn-sm btn-link selected"
};
const _hoisted_28 = ["onClick"];
const _hoisted_29 = ["disabled"];
const _hoisted_30 = { class: "text-end mt-4" };
const _hoisted_31 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.search.nome) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.search.nome]
                    ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.search.cognome) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.search.cognome]
                    ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.search.codiceFiscale) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.search.codiceFiscale]
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.search.ragioneSociale) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.search.ragioneSociale]
                    ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.search.partitaIva) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.search.partitaIva]
                    ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.search.matricola) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.search.matricola]
                    ])
                ])
            ])
        ]),
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
            _createElementVNode("table", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("tbody", null, [
                    (_ctx.list.data.length == 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_22, " Nessuna riga da mostrare "))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.data, (item, i) => {
                        return (_openBlock(), _createElementBlock("tr", {
                            class: _normalizeClass(["pointer", { active: _ctx.selectedItem == item }]),
                            key: i,
                            onClick: ($event) => (_ctx.selectedItem = item)
                        }, [
                            _createElementVNode("td", null, _toDisplayString(item.matricola), 1),
                            _createElementVNode("td", null, _toDisplayString(item.ragione_Sociale), 1),
                            _createElementVNode("td", null, _toDisplayString(item.codice_Fiscale), 1),
                            _createElementVNode("td", null, _toDisplayString(item.partita_Iva), 1)
                        ], 10, _hoisted_23));
                    }), 128))
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-link me-2",
                disabled: _ctx.page == 1,
                onClick: _cache[6] || (_cache[6] =
                    //@ts-ignore
                    (...args) => (_ctx.prev && _ctx.prev(...args)))
            }, "Prec.", 8, _hoisted_25),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prevPages, (p) => {
                return (_openBlock(), _createElementBlock("button", {
                    type: "button",
                    class: "btn btn-sm btn-link me-2",
                    onClick: ($event) => (_ctx.setPage(p))
                }, _toDisplayString(p), 9, _hoisted_26));
            }), 256)),
            _createElementVNode("button", _hoisted_27, _toDisplayString(_ctx.page), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nextPages, (p) => {
                return (_openBlock(), _createElementBlock("button", {
                    type: "button",
                    class: "btn btn-sm btn-link ms-2",
                    onClick: ($event) => (_ctx.setPage(p))
                }, _toDisplayString(p), 9, _hoisted_28));
            }), 256)),
            _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-link ms-2",
                disabled: _ctx.totalPages <= _ctx.page,
                onClick: _cache[7] || (_cache[7] =
                    //@ts-ignore
                    (...args) => (_ctx.next && _ctx.next(...args)))
            }, "Succ.", 8, _hoisted_29)
        ]),
        _createElementVNode("div", _hoisted_30, [
            _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                disabled: !_ctx.selectedItem,
                onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.ok()))
            }, "Seleziona", 8, _hoisted_31)
        ])
    ]));
}
